/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request body for creating an Apple Pay merchant session.
 * @export
 * @interface ApplePayMerchantSessionRequest
 */
export interface ApplePayMerchantSessionRequest {
    /**
     * Validation URL provided by Apple Pay JS.
     * @type {string}
     * @memberof ApplePayMerchantSessionRequest
     */
    validationUrl: string;
}

/**
 * Check if a given object implements the ApplePayMerchantSessionRequest interface.
 */
export function instanceOfApplePayMerchantSessionRequest(value: object): value is ApplePayMerchantSessionRequest {
    if (!('validationUrl' in value) || value['validationUrl'] === undefined) return false;
    return true;
}

export function ApplePayMerchantSessionRequestFromJSON(json: any): ApplePayMerchantSessionRequest {
    return ApplePayMerchantSessionRequestFromJSONTyped(json, false);
}

export function ApplePayMerchantSessionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplePayMerchantSessionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'validationUrl': json['validation_url'],
    };
}

export function ApplePayMerchantSessionRequestToJSON(json: any): ApplePayMerchantSessionRequest {
    return ApplePayMerchantSessionRequestToJSONTyped(json, false);
}

export function ApplePayMerchantSessionRequestToJSONTyped(value?: ApplePayMerchantSessionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validation_url': value['validationUrl'],
    };
}

